import {SurveyModel} from 'survey-core';
import {SurveyData} from './surveyData';

export const completeSurvey = (survey: SurveyModel) => {
  survey.completeLastPage();
  SurveyData.save(survey);
};
